import {ConfirmOptions} from "@toolpad/core/useDialogs/useDialogs";

export const confirmOptions: ConfirmOptions = {
    okText: 'Ja',
    cancelText: 'Nein'
}
